// ** Third Party Components
import { useTranslation } from "react-i18next";
import cookie from "js-cookie";

// ** Styles Imports
import { ButtonPrimary } from "components/layout/Button/ButtonPrimary";
import {
	StyledFallbackContainerOAuth,
	StyledMessageContainerOAuth,
	DatezoneLogoOAuth,
} from "containers/Oauth/OAuth";

// ** Icons Imports
import { LoaderOAuth } from "containers/Oauth/components/LoaderOAuth";

// ** Config
import configGlobal from "configuration";

// #####################################################

const FallbackContent = ({ missingChunkType, reloadPage }) => {
	const { t } = useTranslation();
	const themeMode = cookie.get(configGlobal.theme.cookieName);

	return (
		<StyledFallbackContainerOAuth $isDarkMode={themeMode === "dark"}>
			<StyledMessageContainerOAuth>
				<div style={{ marginBottom: "2rem" }}>
					<DatezoneLogoOAuth isDarkMode={themeMode === "dark"} />
				</div>

				<LoaderOAuth size={50} isDarkMode={themeMode === "dark"} />

				{!missingChunkType && (
					<p
						style={{
							color: themeMode === "dark" ? "#f2f2f2" : "#373737",
							marginTop: "1rem",
						}}
					>
						{t("errors.commonErrorCatch")}
					</p>
				)}

				{window?.location?.hash?.includes("#refresh") && (
					<ButtonPrimary
						mt={8}
						label={t("errors.refresh")}
						type="button"
						onClick={() => reloadPage(true)}
					/>
				)}
			</StyledMessageContainerOAuth>
		</StyledFallbackContainerOAuth>
	);
};

// #####################################################

export default FallbackContent;

// #####################################################
